module.exports = __webpack_public_path__ + "static/media/enLang.ab47e969.svg";